import { StyleSheet, type StyleProp, type ViewStyle } from 'react-native';

/** Contenedor flex para listas operativas (hermano de modales en la misma pantalla). */
export const operationalTabListHostStyle = StyleSheet.create({
  host: {
    flex: 1,
    minHeight: 0,
    minWidth: 0,
    alignSelf: 'stretch',
    width: '100%',
  },
  /**
   * FlatList / ScrollView operativo.
   * En web NO usar `height: '100%'` acá: sin un padre con altura explícita colapsa a 0
   * (Ventas `workspaceScroll`, catálogo pre-refactor con `flex: 1` solamente).
   */
  scroller: {
    flex: 1,
    minHeight: 0,
    alignSelf: 'stretch',
    width: '100%',
  },
});

export function operationalTabListScrollerStyle(
  extra?: StyleProp<ViewStyle>
): StyleProp<ViewStyle> {
  return [operationalTabListHostStyle.scroller, extra];
}
